module.exports = __webpack_public_path__ + "static/img/pic-cnt-5.60e9631.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/en/pic-cnt-5.png
// module id = V+54
// module chunks = 0